import { renderHtmlToPlainText } from './renderHtmlToPlainText'
import { interpolateVariables, type RenderMode } from './interpolateVariables'
import { appendSignature } from './appendSignature'

export type RenderEmailArgs = {
  bodyHtml: string
  signatureHtml: string
  variables: Record<string, string>
  mode: RenderMode
}

/**
 * Render a campaign body + signature to the bytes the recipient will see.
 * Output is byte-equal to the Python port `render_email`. Single entry point
 * shared by every preview surface; the send-path snapshot uses the Python port.
 */
export function renderEmail({
  bodyHtml,
  signatureHtml,
  variables,
  mode,
}: RenderEmailArgs): string {
  const filledBody = interpolateVariables(bodyHtml, variables)
  const renderedBody =
    mode === 'plaintext'
      ? renderHtmlToPlainText(filledBody)
      : filledBody.replace(/\s+$/, '')
  return appendSignature(renderedBody, signatureHtml, mode)
}
